import React, { memo, useMemo, FC } from 'react';
import { GridItem, StackDivider, VStack } from '@chakra-ui/react';
import MenuItemCard from '../../MenuItemCard';

const col = (cols: number) => `repeat(${cols}, 1fr)`;

type T = {
  group?: IMenuGroup;
  isLoading?: boolean;
};

const MenuGroupItemsComponent: FC<T> = ({ group, isLoading }) => {
  const itemsToRender = useMemo(() => {
    if (isLoading) {
      const randomNumber = Math.round(Math.random() * 9999999999999);
      return new Array(12).fill(true).map((_, index) => ({
        id: `loading-item-card-${randomNumber + index}`,
      }));
    }
    return group?.menuItems || [];
  }, [isLoading, group]);

  return (
    <VStack
      display={{ base: 'flex', sm: 'grid' }}
      flexDirection="column"
      gridTemplateColumns={{
        sm: col(2),
        md: col(3),
        xl: col(4),
      }}
      data-testid="menu-item-group-items"
      w="100%"
      gap={{ base: 0, sm: 6 }}
      spacing={4}
      divider={<StackDivider display={{ base: 'block', sm: 'none' }} />}
      px={4}
    >
      {itemsToRender?.map((item: IMenuItem) => (
        <GridItem w={{ base: '100%', md: 'auto' }} key={item?.id} colSpan={1}>
          <MenuItemCard
            item={item}
            groupName={group?.name}
            variant="horizontal"
            isLoading={isLoading}
          />
        </GridItem>
      ))}
    </VStack>
  );
};

export const MenuGroupItems = memo(MenuGroupItemsComponent);
